export default "__VITE_ASSET__D5mjpML9__"